import { ChangeDetectorRef,Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType } from 't4core';
import * as uuid from 'uuid';
import { ServiceGuyInfo } from 't4core';
import { AssetInfo, InventoryAssetInfo, LocationInfo, ServiceGuyTypeInfo } from 't4core';
import { InventoryItemInfo } from '../../../../../dist/t4core';
import { FindLocationDialog } from '../../../../t4common/dialogs/FindLocationDialog/FindLocationDialog';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
  selector: 'ServiceGuyDialog',
  templateUrl: 'ServiceGuyDialog.html',
  styleUrls: ['./ServiceGuyDialog.css']
})
export class ServiceGuyDialog extends DialogBase {
  public guy: ServiceGuyInfo;
  public serviceguystock: any[];
  public serviceGuyType: ServiceGuyTypeInfo;
  public serviceGuysTypes: ServiceGuyTypeInfo[];

  public serviceguySelect: ServiceGuyInfo;
  public inventoryAssets: InventoryAssetInfo;

  public AssignedLocationsCount: number;
  public LocationCheckupsList: LocationInfo[];

  public form = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    companyName: new FormControl('', []),
    phone: new FormControl('', [Validators.required, Validators.pattern(/^\+\d{1,3}\d{3,}$/)]),
    email: new FormControl('', [Validators.required]),
    LocationCheckups: new FormControl(),
    AssingedLocations: new FormControl(),

    customerAccount: new FormControl('', [Validators.required]),
    deliveryaddress: new FormControl('', [Validators.required]),
    deliverycity: new FormControl('', [Validators.required]),
    deliverycountry: new FormControl('', [Validators.required]),
    deliveryzipcode: new FormControl('', [Validators.required]),

    serviceGuyTypeId: new FormControl('', [Validators.required])
     
  });

  @ViewChild("tblAssignedLocations") private assignedLocations: T4DatatableWidget;

  constructor(el: ElementRef,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ServiceGuyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super("ServiceGuyDialog");

    if (data.guy) {
      this.guy = data.guy;

      this.form.setValue(
        {
          firstName: this.guy.Firstname ?? '',
          lastName: this.guy.Lastname ?? '',
          companyName: this.guy.Companyname ?? '',
          email: this.guy.Email ?? '',
          phone: this.guy.Phone ?? '',

          LocationCheckups: this.guy.AssignedLocationsAll ?? '',
          AssingedLocations: this.guy.AssignedLocationsAll ?? '',

          customerAccount: this.guy.CustomerAccount ?? '',
          deliveryaddress: this.guy.DeliveryAddress ?? '',
          deliverycity: this.guy.DeliveryCity ?? '',
          deliverycountry: this.guy.DeliveryCountry ?? '',
          deliveryzipcode: this.guy.DeliveryZipCode ?? '',

          serviceGuyTypeId: (this.guy.ServiceGuyTypeId + '') ?? '0'
        });

      this.serviceGuyType = this.guy.ServiceGuyType;

      this.GetServiceGuyTypes();
    }
  }

  public async ngOnInit() {  
    if (this.guy.Id != null) {
      this.getStock();
      this.GetInventoryAssets();

      this.AssignedLocationsCount = this.guy?.AssignedLocationsCount;
      this.LocationCheckupsList = this.guy?.AssignedLocations;
    }
  }

    public removeImage(id: string) {
    }

  public save() {
    if (!this.form.valid) return;

    var val = this.form.getRawValue();
    this.guy.Firstname = val.firstName;
    this.guy.Lastname = val.lastName;
    this.guy.Companyname = val.companyName;
    this.guy.Phone = val.phone;
    this.guy.Email = val.email;

    this.guy.CustomerAccount = val.customerAccount;
    this.guy.DeliveryAddress = val.deliveryaddress;
    this.guy.DeliveryZipCode = val.deliveryzipcode;
    this.guy.DeliveryCity = val.deliverycity;
    this.guy.DeliveryCountry = val.deliverycountry;

    this.dialogRef.close(true);
  }


  public async updatestock() {

    var ret = await this.UI.openDialog("T4.Service.updateStockDialog", { data: { guy: this.guy } });
    this.getStock();

    if (ret) {
    }

    return ret;
  }

  public async getStock() {
    this.serviceguystock = await this.Api.get<InventoryItemInfo[]>("/Service/GetInStock", { serviceGuyId: this.guy.Id });
  }

  public async GetServiceGuyTypes() {
    this.serviceGuysTypes = await this.Api.get<ServiceGuyTypeInfo[]>("/Service/GetServiceGuyTypes");
  }

  public async GetInventoryAssets() {
    this.inventoryAssets = await this.Api.get<InventoryAssetInfo>("/Service/GetSGInventoryAssets", { serviceGuyId: this.guy.Id });
  }

  public async Transfer(x) {
     console.log(x);
    this.serviceguySelect = await this.UI.openDialog('T4.Service.selectServiceGuy', {
      width: "500px",
      height: "1250px"
    });

    await this.Api.post<boolean>("/Service/TransferAsset", null, { AssetId: x.AssetId, sgId: this.serviceguySelect.Id });

    this.GetInventoryAssets();
  }

  public async Scrap(x) {
    await this.Api.post<boolean>("/Service/ScrapAsset", null, { AssetId: x.AssetId });
    this.GetInventoryAssets();
  }


  public async assetInfomation(AssetId: uuid) {

    var res = await this.Api.get<AssetInfo>("/Service/GetAssetInfo", { Id: AssetId });

    var ret = await this.UI.openDialog('T4.Service.assetInformationDialog', {
      data: res,
      width: "900px",
      height: "650px"
    });
  }

  public async addNewAssignment() {
    /*  await this.loadLocations();*/
    var result = await this.Dialog.open(FindLocationDialog, { data: { Locations: null, SelectedLocation: null, IsOneway: false, isDefault : true, Role: "ServiceGuy" } }).afterClosed().toPromise();
    if (result) {
      if (result.ServiceGuyId ?? null) {
        var ret = await this.UI.confirm('T4.Service.ServiceGuys.ConfirmAssginment', 'Are you sure?', 'T4.Service.ServiceGuys.msgConfirmAssigment', 'The selected location has a service guy connected. Still you want to continue?');
        if (!ret) return;
      }
      await this.Api.post<boolean>("Service/AssignServiceGuy", null, { guyId: this.guy.Id, locationId: result.Id });
      var res = await this.Api.get<LocationInfo>("Service/GetLocationByServiceGuyId", { ServiceGuyId: this.guy.Id });
      if (res) this.assignedLocations.data.data.push(res);
      this.assignedLocations.update();
      this.changeDetectorRef.detectChanges();
    }

  }

}
